export const BANNER_TYPE = {
  info: 'Info',
};

export const FOOTNOTE_SYMBOL = Object.freeze({
  cross: '†',
  asteriskSingle: '*',
  oneSuperscript: '¹',
});
